import { Button, MultipleChoice } from '@unmind/design-system';
import { rem } from 'polished';
import styled from 'styled-components';

export const Container = styled.form`
  padding: ${rem(24)};

  button {
    margin-left: auto;
    display: block;
  }
`;

export const SubmitButton = styled(Button).attrs({
  variant: 'primary',
  type: 'submit',
})`
  align-self: flex-end;

  &:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.background.danger};
  }
`;

export const MultiChoice = styled(MultipleChoice)`
  margin-bottom: ${rem(24)};
`;
